import type { ReactNode } from 'react'

import './stage.css'

// Stage is the wizard frame the prototype is built on: a rail that stays put, a
// body that takes the remaining height, and a footer pinned to the bottom edge.
// Without it the buttons ride up under the text on a tall screen.
export function Stage({
  rail,
  footer,
  top = false,
  flush = false,
  children,
}: {
  rail?: ReactNode
  footer?: ReactNode
  top?: boolean
  flush?: boolean
  children: ReactNode
}) {
  return (
    <div className={flush ? 'stage stage--flush' : 'stage'}>
      {rail ? <div className="stage__rail">{rail}</div> : null}
      <div className={top ? 'stage__body stage__body--top' : 'stage__body'}>{children}</div>
      {footer ? <div className="stage__footer">{footer}</div> : null}
    </div>
  )
}
